import { render, staticRenderFns } from "./open-terms-modal-link.vue?vue&type=template&id=719edf6d"
import script from "./open-terms-modal-link.vue?vue&type=script&lang=js"
export * from "./open-terms-modal-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports